angular.module('iqxCore')
.controller('actionDialogProgressHistoryCtrl', function ($scope, FormSvc, ApplicationSvc, ApiSvc) {
	var customSliceSize = 15
	if(window.outerWidth < 992){
		customSliceSize = 5
	}
	$scope.filters = {}
	$scope.OrderBy = "HistoryDate desc"
	$scope.filters.Position = ""
	$scope.daterangeSet=false
	$scope.filters.StartDate = moment().subtract(6, 'month').toDate()
	$scope.filters.EndDate = moment().toDate()
	$scope.daterangeSet=true
	$scope.filters.CandidateRejectionReason = ""
	$scope.filters.Outcome = ""

	$scope.setDateRange=function(){
		var data={
			xDateFrom: $scope.filters.StartDate,
			xDateTo: $scope.filters.EndDate
		}
		FormSvc.modalForm($scope,'setDateRange',data,'md',{label:'col-sm-3', data:'col-sm-7'})
		.then(function(data){

			$scope.filters.StartDate=data.xDateFrom
			$scope.filters.EndDate=data.xDateTo
			$scope.daterangeSet=true
			$scope.updateResults()
		})
	}

	$scope.setSettings=function(){
		var data={
			xDateFrom: $scope.filters.StartDate,
			xDateTo: $scope.filters.EndDate,
			xPosition: $scope.filters.Position,
			xCandidateRejectionReason: $scope.filters.CandidateRejectionReason,
			xOutcome: $scope.filters.Outcome,
			xOrderBy: $scope.OrderBy
		}
		FormSvc.modalForm($scope,'setSettings',data,'lg',{label:'col-sm-3', data:'col-sm-7'})
		.then(function(data){
			$scope.filters.StartDate=data.xDateFrom
			$scope.filters.EndDate=data.xDateTo
			$scope.filters.Position=data.xPosition
			$scope.filters.CandidateRejectionReason=data.xCandidateRejectionReason
			$scope.filters.Outcome=data.xOutcome
			$scope.OrderBy=data.xOrderBy
			$scope.daterangeSet=true
			$scope.updateResults()
		})
	}

	$scope.updateOrderBy = function(colName){
		var stringLength = colName.length
		if($scope.OrderBy.substring(0, stringLength) == colName){
			if($scope.OrderBy == colName + " asc"){
				$scope.OrderBy = colName + " desc"
			} else if ($scope.OrderBy == colName + " desc"){
				$scope.OrderBy = colName + " asc"
			}
		}else{
			$scope.OrderBy = colName + " asc"
		}
		$scope.updateResults()
	}

	$scope.updateResults = function(){
		var fetchApiString = "callresult/NetClientVacanciesCandidateHistory?pPersonID=" + $scope.actiondialogparams.linkID

		fetchApiString = fetchApiString + '&pOrderBy='+$scope.OrderBy

		angular.forEach($scope.filters, function(value, key) {
  		if (value && value != ""){
				if(key!='StartDate' && key!='EndDate'){
					fetchApiString = fetchApiString + "&pFilter"+key+"="+"%"+value+"%"
				}else{
					fetchApiString = fetchApiString + "&pFilter"+key+"="+moment(value).toISOString()
				}
			}
		})

		FormSvc.setOptions($scope,{
			fetchAPI: fetchApiString,
			multiRow:true,
			sliceSize:customSliceSize,
			dateFields:['HistoryDate']
		})

		$scope.fetch()
	}

	$scope.updateResults()

})
